import TrialsServiceClient from "@seneca/trials-service-client";
import { FeatureType } from "@seneca/trials-service-client/dist/types";

import { Dispatch, GetState } from "common/types";

import errorHandler from "services/trialsService/errorHandler";

import { userHasAccessToWrongAnswersModeThroughTrialOnly } from "features/wrong-answers/selectors/userHasAccessToWrongAnswersMode";

import { updateTrialActionFactory } from "../state";

export const makeRecordTrialEvent = (getClient: () => TrialsServiceClient) => {
  return updateTrialActionFactory({
    requestFunction: type => getClient().recordTrialEvent(type),
    errorHandler
  });
};

export const makeRecordWrongAnswersSessionStudy = (
  getClient: () => TrialsServiceClient
) => {
  const recordTrialEvent = makeRecordTrialEvent(getClient);
  return () =>
    recordTrialEvent(FeatureType.WRONG_ANSWERS, FeatureType.WRONG_ANSWERS);
};

export const makeRecordWrongAnswersSessionStudyIfNeeded = (
  getClient: () => TrialsServiceClient
) => {
  const recordWrongAnswersSessionStudy =
    makeRecordWrongAnswersSessionStudy(getClient);

  return function recordWrongAnswersSessionStudyIfNeeded() {
    return async function (dispatch: Dispatch, getState: GetState) {
      const state = getState();

      if (userHasAccessToWrongAnswersModeThroughTrialOnly(state)) {
        dispatch(recordWrongAnswersSessionStudy());
      }
    };
  };
};
